import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralHowToReferBrandIA = function BrandReferralHowToReferBrandIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_REFER_A_BRAND_TITLE = function BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize) {
  return strictLocalize({
    id: "1pX4bk",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe kun je een merk doorverwijzen"
    }]
  });
};
var BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION = function BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "i4hHoa",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt een merk uitnodigen om op Faire te verkopen door naar ‘Merken doorverwijzen’ te gaan in ‘Account‘, door hun e-mailadres of website toe te voegen of door je doorverwijslink rechtstreeks met hen te delen."
    }]
  });
};